import React from "react";
import Login from "views/auth/login/Login";
import {withApollo} from "config/apolloConfig";

const LoginPage = () => {
    return <Login/>
}

export default withApollo({ssr: true})(LoginPage);